import { FavoriteToggleButton } from '@common';

type FavoritePropsType = {
  isFavorised: boolean;
  onClick: () => void;
};

export const Favorite: React.FC<FavoritePropsType> = ({
  isFavorised,
  onClick,
}) => {
  return <FavoriteToggleButton onClick={onClick} isFavorised={isFavorised} />;
};
